import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const View = ({ data }) => {
  useEffect(() => {
    const scriptElements = [];
    const styleElements = [];

    // Load external scripts
    if (data.externalScripts) {
      const scripts = data.externalScripts.split('\n').filter(url => url.trim());
      
      scripts.forEach(src => {
        const script = document.createElement('script');
        script.src = src.trim();
        script.async = true;
        document.body.appendChild(script);
        scriptElements.push(script);
      });
    }

    // Load external stylesheets
    if (data.externalStyles) {
      const styles = data.externalStyles.split('\n').filter(url => url.trim());
      
      styles.forEach(href => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href.trim();
        document.head.appendChild(link);
        styleElements.push(link);
      });
    }

    // Cleanup function to remove scripts and styles when component unmounts
    return () => {
      scriptElements.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      styleElements.forEach(link => {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
    };
  }, [data.externalScripts, data.externalStyles]);

  return (
    <div className="block html" dangerouslySetInnerHTML={{ __html: data.html }} />
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
